'use strict';

var React = require('react');

var SvgConnectMinor = function SvgConnectMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.95 11a1.5 1.5 0 1 1 0 1.5h-4.7a2.75 2.75 0 0 1-2.75-2.75v-3.5a2.75 2.75 0 0 1 2.75-2.75h5.5a.75.75 0 0 1 0 1.5h-5.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.25a2.75 2.75 0 0 0 2.75-2.75v-3.5a2.75 2.75 0 0 0-2.75-2.75h-4.7a1.5 1.5 0 1 0 0 1.5h4.7c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-5.5a.75.75 0 0 0 0 1.5h5.5Z"
  }));
};
SvgConnectMinor.displayName = "ConnectMinor";

exports.SvgConnectMinor = SvgConnectMinor;
